import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log('[ScrollToTop] Route changed to:', pathname);
    
    // Find the actual scroll container (.m-content)
    const scrollContainer = document.querySelector('.m-content');
    
    if (scrollContainer) {
      console.log('[ScrollToTop] Current .m-content scroll position:', scrollContainer.scrollTop);
      
      // Reset the scroll container immediately
      scrollContainer.scrollTop = 0;
      
      // Also use RAF to ensure it stays at top after content renders
      requestAnimationFrame(() => {
        scrollContainer.scrollTop = 0;
        console.log('[ScrollToTop] After RAF, .m-content scroll position:', scrollContainer.scrollTop);
      });
    } else {
      // Fallback to window for non-mobile views
      console.log('[ScrollToTop] No .m-content found, using window. Current scroll:', window.scrollY);
      window.scrollTo(0, 0);
    }
    
    // Also reset window scroll as a safety measure
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
